function genChallengeMethodsFull(api, apiStrings, language = 'python') {
  return api?.challenge?.map((apiValue, index) => {
    return {
      ...apiValue,
      header: apiStrings?.challenge?.[language]?.[index] || 'API string value undefined',
    };
  });
}

function genSolutionMethodsFull(api, apiStrings, language = 'python') {
  return api?.solution?.map((apiValue, index) => {
    return {
      ...apiValue,
      header: apiStrings?.solution?.[language]?.[index] || 'API string value undefined',
    };
  });
}

export { genChallengeMethodsFull, genSolutionMethodsFull };
